module.exports = "<div class=\"col-xs-12 main\">\n    <h1 class=\"page-header\">Newsletters list</h1>\n    <router-outlet></router-outlet>\n</div>"